import type { ReactNode } from 'react'

/** Fonte de uma afirmação numérica (ADR-015): quem, quando, como. Sem fonte, o número não entra. */
export interface Source {
  label: string
  href?: string
  date?: string
}

/** Rastro — "Fonte: …" em mono 13 apagado. Obrigatório em toda dobra com Metric (gate inverso do verify-anatomy). */
export function Rastro({ source }: { source: Source }) {
  return (
    <p className="z-rastro" data-anatomy="rastro">
      Fonte: {source.href ? <a href={source.href} rel="noopener noreferrer">{source.label}</a> : source.label}
      {source.date ? ` · ${source.date}` : ''}
    </p>
  )
}

export interface MetricProps {
  /** O número, em mono tabular — o único elemento que pode ser "grande" além do título. */
  value: ReactNode
  label: ReactNode
  /** Obrigatório: a métrica sem fonte é a mentira que a marca promete não contar. */
  source: Source
  /** Renderiza o Rastro junto (padrão). Desligue quando a dobra já traz um Rastro coletivo. */
  withRastro?: boolean
}

/** Metric — dado de resultado (estado Cura): valor em mono, rótulo em Schibsted, fonte ao lado. */
export function Metric({ value, label, source, withRastro = true }: MetricProps) {
  return (
    <div className="z-metric" data-metric="">
      <span className="z-metric__valor">{value}</span>
      <span className="z-metric__rotulo">{label}</span>
      {withRastro && <Rastro source={source} />}
    </div>
  )
}

export default Metric
